<div class="item-bag">
  <!-- am-bag-add-content -->
  <div class="" *ngIf="statusBag != StatusBag.DOCUMENT">
    <!-- Para carryon-classic: mostrar checkbox cuando NO está pagado -->
    <div class="bag-title" *ngIf="enableCheck && statusBag != StatusBag.PAID">
      <p>{{ 'bagsSelection.carryOnaddLabel' | translate }}</p>
    </div>
    <div class="bag-actions" *ngIf="enableCheck && statusBag != StatusBag.PAID">
      <div class="">
        <p>{{ subtitleClassic }} {{ cost | amCurrency }}</p>
      </div>
      <app-am-check-box
        [disabled]="connectionBlocked"
        (handleCheck)="onHandleCheck($event)"
        (disabledClick)="onDisabledCheckClick()"
      ></app-am-check-box>
    </div>

    <!-- Para carryon-classic: mostrar texto cuando ESTÁ PAGADO -->
    <div
      class="carry-on-weight-info"
      *ngIf="enableCheck && statusBag == StatusBag.PAID && !usaPaasenger"
    >
      <p class="weight-text">
        Tu equipaje de mano cuenta con<br />
        el peso máximo de <span class="carryon-weight-value">15kg</span>
      </p>
    </div>

    <!-- Para BASIC: mostrar texto informativo cuando enableCheck=false y no es USA -->
    <div
      class="carry-on-weight-info"
      *ngIf="!enableCheck && !usaPaasenger && fareFamily === 'BASIC'"
    >
      <p class="weight-text">
        Tu equipaje de mano cuenta con<br />
        el peso máximo de <span class="carryon-weight-value">15kg</span>
      </p>
    </div>
  </div>
</div>
